var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","align-center":"","pa-0":""}},[_c('ComponentAdminReportNursery72')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }